import React from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { actions } from '../../../../context';
import { Button, ListGroupItem } from 'reactstrap';
import Split from '../../../Shared/Split';

const PluginListItem = ({ 
    pluginId,
    pluginName,
    defaultVersion,
    offering,
    onAddClickSuccess,
}) => {
    const [adding, setAdding] = useState(false);
    const dispatch = useDispatch();

    const addPlugin = (pluginId) => {
        setAdding(true);
        dispatch(actions.missionControl.addPluginToOffering(pluginId, offering))
            .then(() => {
                onAddClickSuccess();
                setAdding(false);
            })
            .catch((error) => {
                console.error("Error adding plugin:", error);
                // You can also handle any errors here if necessary
                setAdding(false);
            });
    };

    const formatTextWithNewLine = (text) => {
        const parts = text.split('\n');
        return (
            <>
                {parts.map((part, index) => (
                    <React.Fragment key={index}>
                        {part}
                        {index !== parts.length - 1 && <br />}
                    </React.Fragment>
                ))}
            </>
        );
    };

    return (
        <div className="text-dark">
            <ListGroupItem key={pluginId}>
                <Split>
                    <div>
                        <div>{pluginName}</div>
                        <div className="text-14 op-7">Uid: {pluginId}</div>
                        <div className="text-14 op-7">Default Version: {formatTextWithNewLine(defaultVersion)}</div>
                    </div>
                    <div>
                        <Button
                            color={'primary'}
                            disabled={adding}
                            size="sm"
                            onClick={() => addPlugin(pluginId)}>
                            {adding ? 'Adding': 'Add'}
                        </Button>
                    </div>
                </Split>
            </ListGroupItem>
        </div>
    );
};

export default PluginListItem;